import './LoadingScreen.css';

interface LoadingScreenProps {
  message?: string;
}

function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div className="loading-screen">
      <div className="loading-spinner" />
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
}

export default LoadingScreen;
